import PropTypes from 'prop-types';
import React from 'react';
import './Option.scss';

const Option = ({
  children,
  onClick,
  hooks,
  value,
  dataHook = ''
}) => (
  <div
    role="button"
    tabIndex={0}
    data-hook={hooks ? `display-${value.name}odds` : dataHook}
    className="mb-dropdown-option"
    onKeyUp={(e) => {
      if (e.key === 'Enter') onClick(value);
    }}
    onClick={(e) => {
      e.preventDefault();
      onClick(value);
    }}
  >
    <div className="mb-dropdown-option__value">
      {children}
    </div>
  </div>
);

Option.propTypes = {
  children: PropTypes.node.isRequired,
  dataHook: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  value: PropTypes.any.isRequired,
  hooks: PropTypes.bool,
  onClick: PropTypes.func
};

export default Option;
